"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Toast_css = _interopRequireDefault(require("./Toast_css.js"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
/**
 * Represents a Toast component.
 *
 * @component
 * @param {Object} props - The properties of the Toast component.
 * @param {string} props.message - The message to be displayed in the Toast.
 * @param {string} props.icon - The icon to be displayed in the Toast.
 * @param {string} props.position - The position of the Toast.
 * @param {boolean} props.isVisible - Determines whether the Toast is visible or not.
 * @param {boolean} props.dismissable - Determines whether the Toast is dismissable or not.
 * @param {function} props.onDismiss - The function to be called when the Toast is dismissed.
 * @returns {JSX.Element} The rendered Toast component.
 */
const Toast = _ref => {
  let {
    message,
    icon = null,
    position = "bottom",
    isVisible,
    dismissable = true,
    onDismiss
  } = _ref;
  (0, _appendCss.default)("arc_toast", _Toast_css.default);
  const toastVisibility = isVisible ? "visible" : "fade-out";
  const toastDefaultClass = "t-body-med";
  const toastDismissable = dismissable ? "dismissable" : "";
  const toastIcon = icon ? "icon" : "";
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `Toast ${toastDefaultClass} Toast-position--${position} ${toastVisibility} ${toastDismissable} ${toastIcon}`,
    role: "status",
    "aria-live": "off",
    "aria-atomic": "true",
    tabIndex: "0"
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "Toast-icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: icon,
    "aria-hidden": "true"
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "Toast-message"
  }, message), dismissable && /*#__PURE__*/_react.default.createElement("span", {
    className: "Toast-icon-close"
  }, " ", /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "button",
    icon: "close",
    "data-testid": "close",
    onClick: onDismiss
  })));
};
var _default = exports.default = Toast;
Toast.propTypes = {
  /** The message to be displayed in the toast. */
  message: _propTypes.default.string.isRequired,
  /** The position of the toast. Possible values: "top", "bottom", "top-left", "top-right", "bottom-left", "bottom-right". */
  position: _propTypes.default.oneOf(["top", "bottom", "top-left", "top-right", "bottom-left", "bottom-right"]),
  /** The icon to be displayed in the toast. A complete list of available icons can be found at: https://material.io/resources/icons */
  icon: _propTypes.default.string,
  /** The duration of toast to be displayed. Default: 3000 */
  duration: _propTypes.default.number,
  /** Indicate if the toast can be dismissable or running based on duration only. Default: true */
  dismissable: _propTypes.default.bool
};